import { nameRoutes } from "../../router/nameRoutes";

import { getRichiesta } from "../../utils/richieste/api";

import N4M from "../../utils/commons";
import LABEL from "../../utils/label";

export const richiestaMixin = {
  props: {
    previousIdPasto: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      LABEL,
      N4M,
      nameRoutes,
      loader: {
        page: true,
      },
      richiesta: {
        data: null,
        pasti: null,
        currentPastoIndex: 0,
      },
      errors: {
        alert: null,
      },
      lateralCard: {
        open: true,
      },
      button: {
        action: (element) => {
          this.$router.push({
            name: nameRoutes.PORTATA,
            params: {
              idRichiesta: this.$route.params.idRichiesta,
              idVassoioItem: element.id,
              idPortata: element.idPortata,
            },
          });
        },
        label: (portata) =>
          portata.label[0].customClass
            ? LABEL.RICHIESTA.CHOOSE_MEAL
            : LABEL.RICHIESTA.CHANGE_MEAL,
        icon: (portata) =>
          portata.label[0].customClass ? "plus-circle" : "pen",
      },
    };
  },
  methods: {
    setAll: async function () {
      const response = await getRichiesta(this.$route.params.idRichiesta);
      const { data: richiesta, result } = response;
      if (result === "KO") {
        this.loader.page = false;
        this.errors.alert = response.code;
        return;
      }
      this.richiesta = {
        ...this.richiesta,
        pasti: this.mapRichiesta(richiesta),
        data: richiesta[0].listaPortate[0].dataRichiesta,
      };
      this.richiesta.currentPastoIndex = this.defineCurrentPastoIndex();

      this.lateralCard.open = this.previousIdPasto ? false : true;
      this.loader.page = false;
    },
    mapRichiesta: function (richiesta) {
      //Nel caso l'utente fosse a digiuno il pasto non avrà portate e il regime alimentare sarà "Digiuno",
      //la descrizione del pasto ( in accordo con il BE ) verrà passata nell'array delle portate

      //il backend passerà sempre almeno un elemento nella lista portate in cui comunicherà descrizione pasto e data richiesta
      //si potrebbe verificare che la lista dei piatti sia null, perciò controllo preventivamente se la condizione è verificata e nel caso comunico a List un array vuoto

      return richiesta.map((pasto) => {
        return {
          idPasto: pasto.idVassoio,
          digiuno: pasto.fDigiuno,
          subTitle: this.defineSubTitlePastoObj(pasto),
          descrizionePasto: N4M.CAPITALIZESTRING(
            pasto.listaPortate[0].descrizionePasto
          ),
          regimeAlimentarePortata: pasto.fDigiuno
            ? LABEL.RICHIESTA.FASTING
            : N4M.CAPITALIZESTRING(pasto.descrizioneMenu),
          portate:
            pasto.fDigiuno || !pasto.listaPortate[0].listaPiatti
              ? []
              : this.mapPortate(pasto.listaPortate, pasto.modificabile),
        };
      });
    },
    mapPortate: function (listaPortate, pastoModificabile) {
      return listaPortate.map(
        ({ listaPiatti, descrizionePortata, idPortata }) => ({
          id: listaPiatti ? listaPiatti[0].idVassoio : null,
          idPortata: idPortata,
          label: this.definePortataLabel(listaPiatti, descrizionePortata),
          button: pastoModificabile,
          checkbox: false,
        })
      );
    },
    definePortataLabel: function (listaPiatti, descrizionePortata) {
      //definisco le label (nome dei piatti selezionati) per ogni portata ( nel caso non ci siano piatti selezionati ritorno una stringa di
      //"default" e imposto una classe particolare alla label )
      return listaPiatti.some((piatto) => piatto.selezionato)
        ? listaPiatti
            .filter((piatto) => piatto.selezionato)
            .map((piattoSel) => ({
              text: N4M.CAPITALIZESTRING(piattoSel.descrizione),
            }))
        : [
            {
              text: LABEL.RICHIESTA.MEAL_NOT_SET(
                N4M.CAPITALIZESTRING(descrizionePortata)
              ),
              customClass: "SisrOrangeLabel",
            },
          ];
    },
    defineCurrentPastoIndex: function () {
      //con questo metodo imposto la tab da mostrare ( tramite l'id del pasto )
      return this.previousIdPasto
        ? this.richiesta.pasti
            .map((pasto, index) => ({
              index: index,
              idPasto: pasto.idPasto,
            }))
            .filter((pasto) => pasto.idPasto === this.previousIdPasto)[0].index
        : 0;
    },
    backToRichieste: function () {
      this.$router.push({
        name: nameRoutes.RICHIESTE,
      });
    },
    setLateralCardOpen: function (index) {
      this.lateralCard.open = !this.lateralCard.open;
      this.richiesta.currentPastoIndex =
        index != undefined ? index : this.richiesta.currentPastoIndex;
    },
    setPortataTabAttribute: function ({ descrizionePasto }) {
      //imposto la base degli attributi per la navigazione bootstrap in base alla descrizione del pasto
      return descrizionePasto.toLowerCase().replaceAll(" ", "_");
    },
    defineSubTitlePastoObj: function (pasto) {
      const ultimaModifica = {
        ora: pasto.oraUltimaModifica,
        data: pasto.dataUltimaModifica,
      };

      //se il pasto è modificato dal reparto o è fuori limite orario e non è a digiuno avrà la classe SisrOrangeLabel
      //se il pasto è modificato dall'utente avrà la classe SisrSmallLabel

      //se il pasto non è modificabile e non è a digiuno controllo se esiste una dieta personalizzata, in quel caso mostro "" altrimenti hourglass-end ( limite orarie superato )
      //

      //se il pasto non è modificabile per via del limite orario viene mostrata l'icona "hourglass-end" e la label NOT_EDITABLE
      //negli altri casi viene mostrata l'icona "user-clock"
      //se il pasto è a digiuno mostro FASTING_ON, e altrimenti mostro LAST_EDIT
      //se pasto.mostraDataOraUltimaModifica è a false ( se è a false vuol dire che l'ultima modifica è stata fatta dall'utente ) mostro LAST_EDIT passando al parametro WHO la label Paziente
      //Altrimenti mostro la label Reparto

      return {
        class: `${
          (pasto.mostraDataOraUltimaModifica ||
            (!pasto.modificabile && !pasto.fDigiuno)) &&
          !pasto.fDigiuno
            ? "SisrOrangeLabel"
            : ""
        } ${
          !pasto.mostraDataOraUltimaModifica &&
          !pasto.fDigiuno &&
          pasto.modificabile
            ? "SisrSmallLabel"
            : ""
        }`,
        icon:
          !pasto.modificabile && !pasto.fDigiuno
            ? pasto.dietaPersonalizzata
              ? "exclamation-circle"
              : "hourglass-end"
            : "user-clock",
        text:
          !pasto.modificabile && !pasto.fDigiuno
            ? LABEL.RICHIESTA.NOT_EDITABLE(pasto.dietaPersonalizzata)
            : pasto.fDigiuno
            ? LABEL.RICHIESTA.FASTING_ON(ultimaModifica)
            : !pasto.mostraDataOraUltimaModifica
            ? LABEL.RICHIESTA.LAST_EDIT(LABEL.RICHIESTA.PATIENT, ultimaModifica)
            : LABEL.RICHIESTA.LAST_EDIT(
                LABEL.RICHIESTA.DEPARTMENT,
                ultimaModifica
              ),
      };
    },
  },
  created() {
    this.setAll();
  },
};
